'use strict';
export type { FrameInfo } from './FrameCallbackRegistryUI';
